import { Page } from '@/core/architecture'

import { DeliveryInfoSettingTemplate } from './template'
import { useViewModel } from './viewModel'

export const DeliveryInfoSetting: Page = () => {
  const { state, actions } = useViewModel()

  return <DeliveryInfoSettingTemplate state={state} {...actions} />
}
